import { useState } from "react";
import { useLocation } from "react-router-dom";
import DynamicMaster from "../../Components/DynamicMaster/DynamicMaster";
import { ActionHandlerProvider } from "../../Components/ActionHandlerContext";


export default function InvestmentCycleMaster() {

    return (
        <>
          <ActionHandlerProvider>
            <DynamicMaster id={3} dashboardId={3} />
          </ActionHandlerProvider>
        </>
      );



}